import React from 'react';
import PropTypes from 'prop-types';

import {Outcome} from '../../Outcome';
import {Option} from './Option';
import {List} from './List';
import {Utilities} from '@learningblocks/exp-constants';
const {
  COMPONENT_TYPE,
  DRAG_DROP_DATA,
  DRAG_DROP__ID,
  DRAG_DROP__TYPE,
} = Utilities;
// import {HexWrapper} from './HexWrapper';

import cn from './style.module.scss';

export function ExperimentOutcomes(props) {
  const onDragStart = (optionId) => (event) => {
    const dropData = {};
    dropData[DRAG_DROP__ID] = optionId;
    dropData[DRAG_DROP__TYPE] = COMPONENT_TYPE.OUTCOME_CARD;
    event.dataTransfer.setData(DRAG_DROP_DATA, JSON.stringify(dropData));
  };

  const onSelect = (optionId) => () => {
    props.onSelect({optionId, componentType: COMPONENT_TYPE.OUTCOME_CARD});
  };

  const renderOptions = (value) => {
    if (value.visible) {
      return (
        <Option
          onDragStart={onDragStart(value.id)}
          key={value.id}
          className={cn.expOutcomeOption}>
          <Outcome
            tabIndex={0}
            // onSelect={console.log}
            title={value.title}
            image={value.image}
            onSelect={onSelect(value.id)}
            glossaryId={value.glossaryId}
            isEmpty={true}
          />
        </Option>
      );
    } else return null;
  };

  return (
    <List className={props.className}>{props.list.map(renderOptions)}</List>
  );
}

ExperimentOutcomes.propTypes = {
  /**
   * data to render on multiple Hexagon
   */
  list: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id number of the each component
       */
      id: PropTypes.number,
      /**
       * card type
       */
      type: PropTypes.string,
      /**
       * title of the Hex card to be rendered
       */
      title: PropTypes.string,
      /**
       * image file path
       */
      image: PropTypes.string,
    })
  ),
  /**
   * className for Experiment component
   */
  className: PropTypes.string,
};

ExperimentOutcomes.defaultProps = {
  className: '',
};
